(function () {
  'use strict';

  var STORAGE_KEY = 'recast_attribution';
  var FBC_BACKUP_COOKIE = '_recast_fbc';
  var FBC_MAX_AGE_SECONDS = 60 * 60 * 24 * 90;
  var TRACKING_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'fbclid',
    'msclkid',
    'ttclid'
  ];

  function readCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function marketingDeclined() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === false);
    } catch (e) {
      return false;
    }
  }

  // Meta fbc format: fb.<subdomain index>.<creation time ms>.<fbclid>
  function buildFbc(fbclid, timestampMs) {
    return 'fb.1.' + timestampMs + '.' + fbclid;
  }

  function fbclidFromFbc(fbc) {
    if (!fbc) return null;
    var parts = fbc.split('.');
    return parts.length >= 4 ? parts.slice(3).join('.') : null;
  }

  function saveFbcBackup(fbclid) {
    if (!fbclid || marketingDeclined()) return;
    // Same click must keep its original timestamp or Meta treats it as a modified fbc.
    if (fbclidFromFbc(readCookie(FBC_BACKUP_COOKIE)) === fbclid) return;

    var cookie = FBC_BACKUP_COOKIE + '=' + encodeURIComponent(buildFbc(fbclid, Date.now())) +
      '; max-age=' + FBC_MAX_AGE_SECONDS + '; path=/; SameSite=Lax';
    if (window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  function captureAttribution() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }

    var fbclid = params.get('fbclid');

    try {
      saveFbcBackup(fbclid);
    } catch (e) {
      /* cookies blocked */
    }

    try {
      var existingRaw = sessionStorage.getItem(STORAGE_KEY);
      if (existingRaw) {
        if (fbclid) {
          var existing = JSON.parse(existingRaw);
          if (existing && !existing.fbclid) {
            existing.fbclid = fbclid;
            existing.fbclid_captured_at = new Date().toISOString();
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
          }
        }
        return;
      }

      var attribution = {
        landing_url: window.location.href,
        landing_path: window.location.pathname,
        captured_at: new Date().toISOString(),
        referrer: document.referrer || null
      };
      var hasTracking = false;

      TRACKING_KEYS.forEach(function (key) {
        if (params.has(key)) {
          attribution[key] = params.get(key);
          hasTracking = true;
        }
      });

      if (window.location.search) {
        attribution.raw_query = window.location.search;
      }

      if (hasTracking || window.location.search) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
      }
    } catch (e) {
      /* sessionStorage blocked */
    }
  }

  function getStoredAttribution() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function fbcFromStored(stored) {
    if (!stored.fbclid) return null;
    var timestamp = Date.parse(stored.fbclid_captured_at || stored.captured_at);
    return buildFbc(stored.fbclid, isNaN(timestamp) ? Date.now() : timestamp);
  }

  function getRecastAttribution() {
    var stored = getStoredAttribution();
    var attribution = {};

    Object.keys(stored).forEach(function (key) {
      attribution[key] = stored[key];
    });

    attribution.landing_url = stored.landing_url || window.location.href;
    attribution.page_url = window.location.href;
    attribution.fbp = readCookie('_fbp');
    attribution.fbc = readCookie('_fbc') || readCookie(FBC_BACKUP_COOKIE) || fbcFromStored(stored);
    attribution.user_agent = (window.navigator && window.navigator.userAgent) || null;

    return attribution;
  }

  window.getRecastAttribution = getRecastAttribution;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', captureAttribution);
  } else {
    captureAttribution();
  }
})();
